import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CustomFieldLabel } from "~/components/CustomFields/CustomFieldInputLabel/CustomFieldLabel";
export const PanelCustomFieldContainer = (param)=>{
    let { canEditCustomFields, canDeleteCustomFields, field, onClick, children } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mb-4 flex w-full flex-col items-start justify-start gap-1",
        children: [
            /*#__PURE__*/ _jsx(CustomFieldLabel, {
                field: field,
                canDeleteCustomFields: canDeleteCustomFields,
                canEditCustomFields: canEditCustomFields,
                onClick: onClick
            }),
            children
        ]
    });
};
